import styled from 'styled-components'

import { Container as CardStyle } from '../../../../components/Card/styles'

export const Container = styled.article`
	min-height: 82vh;
	width: 100%;

	main {
		padding: 35px 50px 35px 90px;
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: auto 0fr auto auto;
		grid-template-areas: 
			'dados_cadastrais'
			'warn'
			'dados_extras'
			'dados_extras';

		@media(max-width: 600px) {
			padding: 20px 10px 20px 10px;
		}

		@media(max-width: 440px) {
			padding: 14px 0;
			display: flex;
			flex-direction: column;
		}
	}
`

export const DadosCadastrais = styled.div`
	grid-area: dados_cadastrais;

	${CardStyle} {
		justify-content: space-between;
		display: grid;
		grid-template-rows: 23px auto 32px auto;
		grid-template-columns: 150px 340px auto 180px;
		grid-gap: 0 34px;
		grid-template-areas:
			'foto x x detail_button'
			'foto nome nome y'
			'foto crm status status'
			'foto data z z';

		> img {
			border-radius: 50%;
		}

		h1 {
			font-size: 28px;
			font-weight: 100;
			color: #FFF;
			text-transform: uppercase;
		}

		span.blue {
			font-weight: 700;
			font-size: 18px;
		}

		span.red {
			font-weight: 700;
			font-size: 18px;
		}

		a {
			transition: 300ms;
			color: #FFF;
			display: flex;
			align-items: center;
			border: solid 1px #FFF;
			padding: 8px 12px;
			border-radius: 6px;

			&:hover {
				opacity: 0.7;
			}

			span {
				font-size: 12px;
				margin-left: 4px;
			}
		}

		.crm {
			display: flex;
			align-items: baseline;

			.situacao {
				display: flex; 
				align-items: center;
				margin-left: 20px;

				svg {
					margin-right: 4px;
				}
			}
		}

		.nome_completo {
			margin-bottom: 8px;
			grid-area: nome;
		}

		.nome_reduzido {
			grid-area: nome;
			display: none;
		}

		.spinner-container {
			grid-column: 1/5;
			grid-row: 1/5;
			align-self: center;
		}

		@media(max-width: 950px) {
			grid-template-rows: 170px auto 32px auto 60px;
			grid-template-columns: 1fr;
			grid-template-areas:
				'foto'
				'nome'
				'crm'
				'data'
				'detail_button';

			img {
				width: 140px;
				justify-self: center;
			}

			h1 {
				justify-self: center;
				font-size: 22px;
			}

			.detail-button {
				align-self: flex-end;
			}

			.nome_completo {
				display: none;
			}

			.nome_reduzido {
				text-align: center;
				display: block;
				margin-bottom: 10px;
			}

			> div {
				justify-self: center;
			}
		}

		@media(max-width: 400px) {
			width: 100%;
			margin: 14px 0 20px;
			grid-template-rows: 170px auto 28px 30px 45px;
			grid-template-columns: 1fr;
			grid-template-areas:
				'foto'
				'nome'
				'crm'
				'data'
				'detail_button';
		}
	}
`

export const Avatar = styled.div`
	grid-area: foto;
	border-radius: 50%;
	width: 150px;
	height: 150px;
	background-image: url(${props => props.image});
	background-position: center;
	background-size: cover;

	@media(max-width: 880px) {
		width: 150px;
		height: 150px;
		padding-top: unset;
	}
`

export const ProjetosContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;

	@media(max-width: 1000px) {
		display: flex;
		flex-direction: column;
	}
`